import Text from 'components/Text/Text';
import React, { useMemo } from 'react';
import { IItemSubCategory } from 'types';
import style from './SubcategoriesList.module.scss';

interface ISubcategoriesList {
	subcategoriesOfCategory: IItemSubCategory[];
}

const SubcategoriesList: React.FC<ISubcategoriesList> = ({ subcategoriesOfCategory }) => {
	const subcategoriesList = useMemo(() => {
		return subcategoriesOfCategory.map((el) => (
			<div className={style.item} key={el.id}>
				<div className={style.dot} />
				<Text translationKey={el.name} withTooltip={true} />
			</div>
		));
	}, [subcategoriesOfCategory]);

	return (
		<>
			<div className={style.listOfItems} data-test="SubcategoriesList">
				{subcategoriesOfCategory.length ? subcategoriesList : '-'}
			</div>
		</>
	);
};

export default React.memo(SubcategoriesList);
